import { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Container, Row, Col, Button, Form, Stack, Table, Tab } from 'react-bootstrap';
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { FcPlus, FcList, FcApproval, FcDataConfiguration } from "react-icons/fc";
import { TiEdit, TiDeleteOutline } from "react-icons/ti";

import { fileFormatList } from '../../constant/index';
import ProcessFileService from "../../services/processFile.service";
import TempProjectFileDataService from "../../services/tempProjectFile.service";
import ProjectStructureService from "../../services/projectStructure.service";
import ProjectDataService from "../../services/project.service";
import FormInputText from "../../components/FormField/FormInput";
import FormSelect from "../../components/FormField/FormSelect";
import FormCheckbox from "../../components/FormField/FormCheckbox";
import TableRow from '../../components/layout/TableRow';
import TableColumnRow from '../../components/layout/TableColumnRow';
import { useAuthContext } from "../../contexts/AuthContext";

import "./Structure.scss";





function StructureCreate() {

  const navigate = useNavigate();
  const location = useLocation();
  const { setIsLoading } = useAuthContext();

  let { projectId, structureId } = useParams();
  const [structureName, setStructureName] = useState("");
  const [structureCode, setStructureCode] = useState("");
  const [structureDescription, setStructureDescription] = useState("");
  const [fileFormat, setFileFormat] = useState("");
  const [fileType, setFileType] = useState([]);
  const [fileTypeSelected, setFileTypeSelected] = useState();
  const [fileFormatSelected, setFileFormatSelected] = useState("");
  const [delimitor, setDelimitor] = useState();
  const [hasHeader, setHasHeader] = useState(false);
  
  const [fileTypeName, setFileTypeName] = useState("");
  
  const [structure, setStructure] = useState("");
  const [project, setProject] = useState("");
  const [fileArray, setFileArray] = useState([]);
  const [masterKeys, setMasterKeys] = useState([]);
  const [recordType, setRecordType] = useState([]);
  const [selectedFileFormat, setSelectedFileFormat] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [file, setFile] = useState(null);

  const [supplierList, setSupplierList] = useState([]);
  const [supplierFilteredList, setSupplierFilteredList] = useState([]);
  const [showModalSupplier, setShowModalSupplier] = useState(false);
  const [supplierNameTxt, setSupplierNameTxt] = useState("");
  const [supplierCodeTxt, setSupplierCodeTxt] = useState("");
  const [supplierAddressTxt, setSupplierAddressTxt] = useState("");
  const [enableProjectStructure, setEnableProjectStructure] = useState(false);
  const [projectStructureList, setProjectStructureList] = useState([]);
  const [projectStructureSelected, setProjectStructureSelected] = useState("");
  const [showStructureFormFields, setShowStructureFormFields] = useState(false);
  const [testRunBtn, setTestRunBtn] = useState(true);
  const [viewTable, setViewTable] = useState(false);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [columnsRows, setColumnsRows] = useState();
  const [headers, setHeaders] = useState();
  const [rows, setRows] = useState();

  const [headerObject, setHeaderObjects] = useState("");
  const [headerObjectRecord, setHeaderObjectRecords] = useState("");
  const [trailerObject, setTrailerObjects] = useState();
  const [trailerObjectRecord, setTrailerObjectRecord] = useState();
  const [masterKeyFieldSubmit, setMasterKeyFieldSubmit] = useState(false);
  const [masterKeyFieldName, setMasterKeyFieldName] = useState({ value: "", isValid: false });
  const [masterKeyDataType, setMasterKeyDataType] = useState({ value: "", isValid: false });
  const [masterKeyRecordType, setMasterKeyRecordType] = useState({ value: "", isValid: false });
  const [masterFieldKeys, setMasterFieldKeys] = useState([]);

  const [fileFormatCondition, setFileFormatCondition] = useState("");
  const [metaDataFieldName, setMetaDataFieldName] = useState();
  const [metaDataFieldValue, setMetaDataFieldValue] = useState();
  const [metadata, setMetadata] = useState([]);
  const [showMetadata, setShowMetadata] = useState(false);

  const [showSupplierName, setShowSupplierName] = useState(true);
  const [supplierNameRow, setSupplierNameRow] = useState();
  const [periodRangeRow, setPeriodRangeRow] = useState();
  const [dataHeaderRow, setDataHeaderRow] = useState();
  const [mergedCell, setMergedCell] = useState();
  const [validationColumn, setValidationColumn] = useState();
  const [exceptionKeywords, setExceptionKeywords] = useState();
  const [supplierName, setSupplierName] = useState();
  const [periodRange, setPeriodRange] = useState();

  const [previewTable, setPreviewTable] = useState({});
  
  
  

  // const [headerHeaders, setHeadeHeaders] = useState([]);
  // const [rowRows, setRowRows] = useState([]);

  // const [headers, setHeaders] = useState();
  // const [rows, setRows] = useState();

  const isEdit = (structureId && location && location.pathname && location.pathname.includes('/edit')) ? true : false;
  const isView = (structureId && location && location.pathname && !location.pathname.includes('/edit')) ? true : false;
  const isCreate = (!structureId) ? true : false;


  useEffect(() => {
    if(structureId !== undefined){
      retrieveStructureDetails(structureId);
    }
    retrieveProjectDetails(projectId);
  }, [projectId, structureId]);

  useEffect(() => {
    if(structure){
      setStructureName(structure.structureName);
      setFileFormat(structure.fileFormat);
      setFileType(structure.fileType);
      setRecordType(structure.recordType);
      setMasterFieldKeys(structure.masterFieldKeys);
      setFileTypeName(structure.fileType?.name);
      setFileName(structure.file_Name);
      setFileTypeSelected(structure.fileType && structure.fileType.id);
      setFileFormatSelected(structure.fileFormat);
      setFileFormatCondition(structure.fileFormatCondition);
      setMetadata(structure.metadata);
      setSupplierNameRow(structure.supplierNameRow);
      setPeriodRangeRow(structure.periodRangeRow);
      setDataHeaderRow(structure.dataHeaderRow);
      setMergedCell(structure.mergedCell);
      setValidationColumn(structure.validationColumn);
      setExceptionKeywords(structure.exceptionKeywords);
      setDelimitor(structure.delimitor);
      setHasHeader(structure.hasHeader);
      setFileUploaded(true);
    }
  }, [structure]);

  useEffect(() => {
    if(masterFieldKeys && masterFieldKeys.length){

      let masterdKeys = masterKeys.masterFieldKeys.push([...masterFieldKeys]);
      setRecordType(masterdKeys);
    }
  }, [masterFieldKeys]);

  function retrieveStructureDetails(structureId) {
    setIsLoading(true);
    ProjectStructureService.get(structureId).then((response) => {
      setIsLoading(false);
      setStructure(response.data.data);
    });
  }


  function retrieveProjectDetails(projectId) {
    setIsLoading(true);
    ProjectDataService.get(projectId).then((response) => {
      setIsLoading(false);
      setProject(response.data.data);
      const fileArray = response.data.data.masterKeys.map(item => {
        return { 
          "id": item._id,
          "name": item._id,
          "label": item.masterKeyName
        }
      });
      setFileArray(fileArray);
      setMasterKeys(response.data.data.masterKeys);
    });
  }


  const setFileTypeFunction  = (value) => {
    const selectedFileFormat = masterKeys.filter((item) => item._id === value);
    console.log(selectedFileFormat);
    console.log(value);
    setFileType({
      name: selectedFileFormat[0].masterKeyName,
      id: value,
    });
    setFileTypeSelected(value);
    setSelectedFileFormat(selectedFileFormat[0]);
    console.log('selectedFileFormat[0].masterKeyFields', selectedFileFormat[0].masterKeyFields);
    if(isCreate) {
      setRecordType(selectedFileFormat[0].masterKeyFields);
    }
  }

  const setFileFormatFunction  = (value, name) => {
    const selectedFileFormat = fileFormatList.filter((item) => item.name === value);
    console.log(selectedFileFormat);
    console.log(value);
    setFileFormat({
      name: value,
      id: value,
    });
    //setFileFormat(value);
    setFileFormatSelected(value);
  }


  const createEditStructure = () => {

    if(!projectId) {
      toast.warning("Project is required.");
      return true;
    }

    console.log('fileFormat', fileFormat);
    console.log('fileFormatSelected', fileFormatSelected);

    var data = {
      projectId,
      fileFormat: fileFormatSelected,
      fileType,
      file_Name: fileName,
      structureName,
      fileFormatCondition,
      metadata,
      recordType,
      masterFieldKeys,
      supplierNameRow,
      periodRangeRow,
      dataHeaderRow,
      mergedCell,
      validationColumn,
      exceptionKeywords,
      delimitor,
      hasHeader
    };

    console.log('createEditStructure.fileName', fileName);

    console.log('createEditStructure.data', data);

    if(isEdit){
      setIsLoading(true);
      ProjectStructureService.update(structureId, data).then((response) => {
        setIsLoading(false);
        if(response.data.success){
          toast.success("Structure Updated!");
          navigate("/project/" + projectId + "/structure");
        } else {
          toast.error("Error in updating structure");
        }
        
      });
    } else if(isCreate){
      setIsLoading(true);
      ProjectStructureService.create(data).then((response) => {
        setIsLoading(false);
        if(response.data.success){
          toast.success("Structure Created!");
          navigate("/project/" + projectId + "/structure");
        } else {
          toast.error("Error in creating structure");
        } 
      });
    }
  };

  const handleHeaderChange = (value, name) => {
    console.log('handleHeaderChange', value, name);
    let recordTypeArray = recordType.length > 0 ? [...recordType] : [...selectedFileFormat.masterKeyFields];

    console.log('recordTypeArray', recordTypeArray);

    recordTypeArray.map(item => {
      if(item.fieldName === name) {
        item.fieldName = name;
        item.source = name;
        item.startPosition = Number(value);
        item.target = value === "Select Target Field" ? '' : value;
      }
    });
    setRecordType(recordTypeArray);
  }

  const handleStartPositionChange = (value, name) => {
    console.log('handleStartPositionChange', value, name);
    let recordTypeArray = recordType.length > 0 ? [...recordType] : [...selectedFileFormat.masterKeyFields];

    console.log('recordTypeArray', recordTypeArray);

    recordTypeArray.map(item => {
      if(item.fieldName === name) {
        item.fieldName = name;
        item.startPosition = Number(value);
      }
    });
    setRecordType(recordTypeArray);
  }

  const handleEndPositionChange = (value, name) => {
    
    let recordTypeArray = recordType.length > 0 ? [...recordType] : [...selectedFileFormat.masterKeyFields];
    recordTypeArray.map(item => {
      if(item.fieldName === name) {
        item.fieldName = name;
        item.endPosition = Number(value);
      }
    });
    setRecordType(recordTypeArray);
  }

  const handlePositionLengthChange = (value, name) => {
    let recordTypeArray = recordType.length > 0 ? [...recordType] : [...selectedFileFormat.masterKeyFields];

    recordTypeArray.map(item => {
      if(item.fieldName === name) {
        item.fieldName = name;
        item.positionLength = Number(value);
      }
    });
    setRecordType(recordTypeArray);
  }

  const readFile = (e) => {
    
    console.log('readFile');
    const { target } = e;
    let file = null;

    if (target.files && target.files.length > 0) {
        file = target.files[0];

        // validateFileAttached(file);

        // if (!isValidExtension(file.name)) {
        //   toast.error("File Extension Incorrect");
        //   return;
        // }
    }
    
    var data = {
        projectId:projectId,
        structureName: structureName,
        fileType: fileType,
        file: file,
    }
    setIsLoading(true);
    TempProjectFileDataService.create(data)
      .then((response) => {
        setIsLoading(false);
        if(response.data.success){ // check for success
          if(response.data.success){
            //toast.success("Project File has been created successfully.!");
          }
          console.log('response.data.setFileName', response.data.data.file);
          setFileName(response.data.data.file);
          viewOriginalFile(file);
        }else{
          if(response.data.err.message){ // fields error
            toast.error("Error in creating Project File");
          }
          else{ // mongo error
            toast.error("Duplicate Project File");
          }
        }
      
    });

    console.log(file);
    setFile(file);
}

  const viewOriginalFile = (file, runtype) => {
    let finalFileName = fileName;
    if(file){
      finalFileName = file.name;
    }
    if(finalFileName){

      let structureObj = structure;
      structureObj.fileFormatCondition = "";

      if(structure === ""){
        structureObj = {
          fileType: fileType.name,
          projectId,
          structureName,
          fileFormat: fileFormat.name,
          fileFormatCondition: "",
          metadata,
          recordType,
          masterKeys,
          delimitor,
        }
      } 

      let state = {
        runtype: runtype,
        projectId,
        fileFormat: fileFormat.name || fileFormat,
        fileType,
        structure: structureObj,
        masterKeys,
        recordType,
        fileName,
        projectStructureList,
        columnsRows,
        headers,
        rows,
        fileFormatCondition: "",
        processType: 'structure',
        supplierNameRow,
        periodRangeRow,
        dataHeaderRow,
        mergedCell,
        validationColumn,
        exceptionKeywords,
      };

      setIsLoading(true);
      ProcessFileService.viewOriginalFile({state: state, fileName: finalFileName, projectId: projectId  }).then((response) => {
        setIsLoading(false);
        if(response.data && response.data.output){
          const output = response.data.output;
          console.log('output', output);
          setViewTable(true);
          if(output.message){
            toast.error(output.message);
            return;
          }
          if(recordType && recordType.length > 0){
            console.log('output.headerData', output.headerData);
            const headerData = output.headerData.map(item => {
              return { 
                "id": item,
                "name": item,
                "label": "Col " +item
              }
            });
            console.log('headerData', headerData);

            setHeaders(headerData);
            setPreviewTable(output.tablePreviewData);
            setViewTable(true);
            setPeriodRange(output.dateRange);
            setSupplierName(output.supplierName);
            //setRows(output);
            // const headerData = output.headerData.map(item => {
            //   return { 
            //     "id": item,
            //     "name": item,
            //     "label": item
            //   }
            // });
            //console.log('output.headerData', output.headerData);
            // setHeaders(headerData || []);
            setFileUploaded(true);
            // setHeaderObjects(output.headerObject.headerData);
            // setHeaderObjectRecords(output.headerObject.rowData);
            // setTrailerObjects(output.trailerObject.headerData);
            // setTrailerObjectRecord(output.trailerObject.rowData);
            
            // setRowRows(output.headerObject);
            // setHeadeHeaders(output.headerObject.headerData || []);
          } else {
            setHeaders(output.headerData || []);
            //setHeadeHeaders(putput.headerObject.headerData || []);
          }
        }
        setTestRunBtn(true);
        setViewTable(true);
        setShowSaveBtn(true);
      });

    } else {
      console.error('No File Name Provided');
    }

    
  }

  const onChangeMasterKeyFieldName = (value) => {
    let isValid = value ? true : false;
    setMasterKeyFieldName({
        ...masterKeyFieldName,
        value: value,
        isValid: isValid,
    });
  }

  const handleAddMasterFieldKeys = () => {

    console.log('handleAddMasterFieldKeys',masterKeyFieldName);

    setMasterKeyFieldSubmit(true);

    if (masterKeyFieldName.isValid) {
      var tableColumn = {};
      tableColumn.recordType = masterKeyRecordType.value;
      tableColumn.fieldName = masterKeyFieldName.value;
      tableColumn.dataType = masterKeyDataType.value;
      // tableColumn.isRequired = isRequired;
      // tableColumn.isPrimaryKey = isPrimaryKey;
      setMasterKeyFieldName({
        value: "",
        isValid: false,
      });
      setMasterKeyFieldSubmit(false);
      console.log('tableColumn', tableColumn);
      setMasterFieldKeys([...masterFieldKeys, tableColumn]);
    }
  }

  const deleteMasterKeyFieldName = (fieldName) => {
    var data = masterFieldKeys.filter(function (item) {
      return item.fieldName !== fieldName;
    });
    setMasterFieldKeys(data);
  }

  const clearData = () => {
    setRows("");
  }

  const onChangeMMetadataFieldValue = (value, name) => {
    let updatedMetadata = metadata.filter(function (item) {
      if(item.metadataName === name){
       return item;
      }
    });
    updatedMetadata[0].metadataValue = value;

    setMetadata([...metadata], updatedMetadata);
  }

  const addMetaData = () => {
    setShowMetadata(!showMetadata);
  }

  const handleAddMetaData = () => {
    let metadataArray = metadata.length > 0 ? [...metadata] : [];
    metadataArray.push({
        metadataName: metaDataFieldName,
        metadataValue: metaDataFieldValue
    });
    setMetadata(metadataArray);
    setMetaDataFieldName("");
    setMetaDataFieldValue("");
  }

  const totalRowProcessed = rows && rows.rowData && rows.rowData.length > 0 ? rows.rowData.length : 0 || 0;
  const totalRowCount = rows && rows.totalRowCount || 0;
  const totalEmptyRowCount = rows && rows.totalEmptyRowCount || 0;

  console.log('headerObject', headerObject);
  
  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 mb-2 pageTitle">{isEdit ? 'Edit' : isView ? 'View' : 'Create New'} Structure / Master</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={2}>
            <Button
              className="btn btn-light mt-4"
              theme="accent"
              onClick={() => navigate(`/project/${projectId}/structure`)}
            >
              <FcList /> View All
            </Button>
            {!isView && (
              <Button
                className="btn btn-primary mt-4"
                theme="accent"
                onClick={() => addMetaData()}
              >
                <FcPlus /> Add MetaData
              </Button>
            )}
          </Stack>
          
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <Form>
            <Row>
              <Col md="12" className="form-group">
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Structure Name</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      structureName
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Structure Name"
                          value={structureName}
                          setFunc={setStructureName}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Structure Code</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      structureCode
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Structure Code"
                          value={structureCode}
                          setFunc={setStructureCode}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Structure Description</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      structureDescription
                    ) : (
                        <FormInputText
                          className="forminput"
                          placeholder="Structure Description"
                          value={structureDescription}
                          setFunc={setStructureDescription}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row> 

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Type</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileTypeSelected
                    ) : (
                      <FormSelect
                        className="forminput"
                        placeholder="Select File Type"
                        optionList={fileArray}
                        value={fileTypeSelected}
                        setFunc={setFileTypeFunction}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">File Format Condition</label>
                    <br />
                    *line starts with character
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormatCondition
                    ) : (
                      <FormInputText
                          className="forminput"
                          placeholder="File Format Condition"
                          value={fileFormatCondition}
                          setFunc={setFileFormatCondition}
                          showLabel={false}
                        />
                    )}
                  </Col>
                </Row>

                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Format Type</label>
                  </Col>
                  <Col className="form-field" md="8">
                    {(isView) ? (
                      fileFormatSelected
                    ) : (
                      <FormSelect
                        className="forminput"
                        placeholder="Select Format"
                        optionList={fileFormatList}
                        value={fileFormatSelected}
                        setFunc={setFileFormatFunction}
                        showLabel={false}
                      />
                    )}
                  </Col>
                </Row>

                {fileFormatSelected === 'delimit' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="feFirstName">Delimit Character</label>
                    </Col>
                    <Col className="form-field" md="8">
                      {(isView) ? (
                        delimitor
                      ) : (
                        <FormInputText
                            className="forminput"
                            placeholder="Delimitor"
                            value={delimitor}
                            setFunc={setDelimitor}
                            showLabel={false}
                          />
                      )}
                    </Col>
                  </Row>
                )}

                {fileFormatSelected === 'delimit' && (
                  <Row className="form-group-row">
                    <Col className="form-label" md="4">
                      <label htmlFor="isIntermeditaryDataDatabase">has header</label>
                    </Col>
                    <Col className="form-field" md="8">
                      <BootstrapSwitchButton
                        checked={hasHeader}
                        id="hasHeader"
                        onlabel="Yes"
                        offlabel="No"
                        onChange={(val) => setHasHeader(val)}
                      />
                    </Col>
                  </Row>
                )}

                {(fileFormatSelected === 'excel' || fileFormatSelected === 'csv' || fileFormatSelected === 'txt') && (
                  <>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierNameRow">Supplier Name Row</label></Col>
                      <Col className="form-field" md="8">
                        <FormInputText
                            id="supplierNameRow"
                            placeholder="Supplier Name Row"
                            className="forminput"
                            value={supplierNameRow}
                            setFunc={setSupplierNameRow}
                            showLabel={false}
                        />
                        </Col>
                    </Row>
                  

                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierStatmentPeriodRow">Supplier Statement period Row</label></Col>
                      <Col className="form-field" md="8">
                        <FormInputText
                            id="supplierStatmentPeriodRow"
                            placeholder="Period Range Row"
                            className="forminput"
                            value={periodRangeRow}
                            setFunc={setPeriodRangeRow}
                            showLabel={false}
                        />
                      </Col>
                    </Row>
                    
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="dataHeaderRow">Data Header Row</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="dataHeaderRow"
                              placeholder="Header Row"
                              className="forminput"
                              value={dataHeaderRow}
                              setFunc={setDataHeaderRow}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="mergedColumns">Merged Columns</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="mergedColumns"
                              placeholder="Merged Row"
                              className="forminput"
                              value={mergedCell}
                              setFunc={setMergedCell}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="validationColumn">Validation Column</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="validationColumn"
                              placeholder="Validation Column"
                              className="forminput"
                              value={validationColumn}
                              setFunc={setValidationColumn}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="exceptionKeywords">Exception Keywords</label></Col>
                        <Col className="form-field" md="8">
                          <FormInputText
                              id="exceptionKeywords"
                              placeholder="Exception Keywords"
                              className="forminput"
                              value={exceptionKeywords}
                              setFunc={setExceptionKeywords}
                              showLabel={false}
                          />
                        </Col>
                      </Row>
                    
                

                    <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Supplier Name</label></Col>
                        <Col className="form-field" md="8">
                          {supplierName}
                        </Col>
                      </Row>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierName">Report Date Range </label></Col>
                        <Col className="form-field" md="8">
                          {periodRange && (periodRange.join(" To "))}
                        </Col>
                    </Row>
                  </>
                )}

                {metadata && metadata.map((mdItem, mdIndex) => {
                    return (
                      <Row className="form-group-row border-bottom-button ml-2 mr-2"  key={`metadata-${mdIndex} + 1`}>
                        <Col className="form-label" md="4">
                          {mdItem.metadataName}
                        </Col>
                        <Col className="form-field" md="8">
                          {(isView) ? (
                            `${mdItem.metadataValue}`
                          ) : (
                            <FormInputText
                                id={`metadataValue-${mdIndex}`}
                                placeholder="Metadata Value"
                                value={mdItem.metadataValue}
                                name={mdItem.metadataName}
                                setFunc={onChangeMMetadataFieldValue}
                                showLabel={false}
                              />
                          )}
                          </Col>
                      </Row>
                    );
                })}

                {showMetadata && !isView && (
                  <Row className="form-group-row border-bottom-button ml-2 mr-2">
                    <Col className="form-field" md="12">
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                          Meta Data Name:
                        </Col>
                        <Col className="form-field" md="6">
                          Meta Data Value:
                        </Col>
                        <Col className="form-field" md="2">
                        </Col>
                      </Row>
                      <Row className="form-group-row border-bottom-button ml-2 mr-2">
                        <Col className="form-field" md="4">
                            <FormInputText
                              id="metadataName"
                              placeholder="Metadata Name"
                              value={metaDataFieldName}
                              setFunc={setMetaDataFieldName}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="6">
                            <FormInputText
                              id="metadataValue"
                              placeholder="Metadata Value"
                              value={metaDataFieldValue}
                              setFunc={setMetaDataFieldValue}
                              showLabel={false}
                            />
                        </Col>
                        <Col className="form-field" md="2">
                          <Button variant="primary" onClick={() => handleAddMetaData()}>
                              {/* <FcPlus size="16" />  */}
                              Add 
                            </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}


                <Row  className="form-group-row">
                  <Col className="form-label" md="4"><label htmlFor="feFirstName">Select File</label></Col>
                  <Col className="form-field" md="8">
                    <div className="custom-file mb-3">
                      <input 
                          type="file" 
                          className="custom-file-input" 
                          id="file" 
                          name="file"
                          placeholder="Upload your excel file"
                          onChange={readFile.bind(this)}
                      />
                      <label className="custom-file-label" htmlFor="customFile2">
                        Choose file...
                      </label>
                    </div>
                    
                    {structureId && (
                      <div><FcApproval /> Uploaded Name: {fileName}</div>
                    )}
                    {fileUploaded && (
                      <div><FcApproval /> File Name: {file && file.name}</div>
                    )}
                  </Col>
                </Row>


                <Row className="form-group-row">
                  <Col className="form-field font-bold" md="12"><label htmlFor="feFirstName">Record Type Mapping</label></Col>
                </Row>
                {fileFormatSelected === 'fixed' && (
                  <Row className="form-group-row">
                      <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="startPosition">Start Position</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="endPosition">End Position</label></Col>
                      <Col className="form-label" md="3"><label htmlFor="positionLength">Position Length</label></Col>
                  </Row>
                )}
                {fileFormatSelected === 'delimit' && (
                  <Row className="form-group-row">
                      <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                      <Col className="form-label" md="9"><label htmlFor="startPosition">Target Column Mapping</label></Col>
                  </Row>
                )}
                {(fileFormatSelected === 'excel' || fileFormatSelected === 'csv' || fileFormatSelected === 'txt') && (
                  <Row className="form-group-row">
                      <Col className="form-label" md="3"><label htmlFor="recordType">Record Type</label></Col>
                      <Col className="form-label" md="9"><label htmlFor="startPosition">Target Column Mapping</label></Col>
                  </Row>
                )}

                {recordType && recordType.map((mitem,mindex) => {

                  return (
                    <Row key={`${mindex}-fixed`}>
                      <Col>
                        {fileFormatSelected === 'fixed' && (
                          <Row className="form-group-row">
                            <Col className="form-label" md="3"><label htmlFor="feFirstName">{mitem.fieldName}</label></Col>
                            <Col className="form-field" md="3">
                              <FormInputText
                                type="number"
                                className="forminput"
                                placeholder="Start Position"
                                value={mitem.startPosition}
                                name={mitem.fieldName}
                                setFunc={handleStartPositionChange}
                                showLabel={false}
                                disabled={isView}
                              />
                            </Col>
                            <Col className="form-field" md="3">
                              <FormInputText
                                type="number"
                                className="forminput"
                                placeholder="End Position"
                                value={mitem.endPosition}
                                name={mitem.fieldName}
                                setFunc={handleEndPositionChange}
                                showLabel={false}
                                disabled={isView}
                              />
                            </Col>
                            <Col className="form-field" md="3">
                              <FormInputText
                                type="number"
                                className="forminput"
                                placeholder="Position length"
                                value={mitem.positionLength}
                                name={mitem.fieldName}
                                setFunc={handlePositionLengthChange}
                                showLabel={false}
                                disabled={isView}
                              />
                            </Col>
                          </Row>
                        )}
                        {fileFormatSelected === 'delimit' && (
                          <Row className="form-group-row">
                            <Col className="form-label" md="3"><label htmlFor="feFirstName">{mitem.fieldName}</label></Col>
                            <Col className="form-field" md="9">
                              <FormSelect
                                  name={mitem.source || mitem.fieldName} 
                                  id={mitem.source || mitem.fieldName}
                                  className="forminput"
                                  placeholder="Select Target Field"
                                  optionList={headers}
                                  value={mitem.target}
                                  setFunc={handleHeaderChange}
                                  showLabel={false}
                                  item={mitem.source || mitem.fieldName}
                                />
                            </Col>
                          </Row>
                        )}
                        {(fileFormatSelected === 'excel' || fileFormatSelected === 'csv' || fileFormatSelected === 'txt') && (
                          <Row className="form-group-row">
                            <Col className="form-label" md="3"><label htmlFor="feFirstName">{mitem.fieldName}</label></Col>
                            <Col className="form-field" md="8">
                                {/* <FormSelect
                                  name={mitem.source || mitem.fieldName} 
                                  id={mitem.source || mitem.fieldName}
                                  className="forminput"
                                  placeholder="Select Target Field"
                                  optionList={headers}
                                  value={mitem.target}
                                  setFunc={handleHeaderChange}
                                  showLabel={false}
                                  item={mitem.source || mitem.fieldName}
                                /> */}
                              {fileUploaded ? ( // if previously uploaded
                                <FormSelect
                                  name={mitem.source || mitem.fieldName} 
                                  id={mitem.source || mitem.fieldName}
                                  className="forminput"
                                  placeholder="Select Target Field"
                                  optionList={headers}
                                  value={mitem.target}
                                  setFunc={handleHeaderChange}
                                  showLabel={false}
                                  item={mitem.source || mitem.fieldName}
                                />
                              ):(
                                <FormSelect name={mitem.target} id={mitem.target} onChange={handleHeaderChange}>
                                    <option>Select Target Field</option>
                                    <option key={mindex+1+10} value={mitem.target} selected>{mitem.target}</option>
                                </FormSelect>
                              )}
                              {/* {fileUploaded ? ( // if previously uploaded
                                
                                <FormSelect name={mitem.source || mitem.fieldName} id={mitem.source || mitem.fieldName} onChange={handleHeaderChange}>
                                  <option>Select Target Field</option>
                                  {headers}
                                    {headers && headers.length && headers.map(function (items, index) {
                                          if((items.toString() === mitem.target))
                                          return <option key={mindex+index} value={mitem.target} selected>{mitem.target}</option>
                                          else
                                          return <option key={mindex+index} value={items}>{items}</option>
                                      })
                                    }


                                </FormSelect>
                                ):(
                                  <FormSelect name={mitem.target} id={mitem.target} onChange={handleHeaderChange}>
                                    <option>Select Target Field</option>
                                    <option key={mindex+1+10} value={mitem.target} selected>{mitem.target}</option>
                                  </FormSelect>
                                )
                              } */}
                            </Col>
                            {/* <Col className="form-field" md="9">
                              <FormInputText
                                type="default"
                                className="forminput"
                                placeholder={mitem.fieldName}
                                value={mitem.startPosition}
                                name={mitem.fieldName}
                                setFunc={handleStartPositionChange}
                                showLabel={false}
                                disabled={isView}
                              />
                            </Col> */}
                          </Row>
                        )}
                      </Col>
                    </Row>
                    
                  )}
                )}

                <Row  className="form-group-row">
                  <Col className="form-button" md="4">
                      <Button className="btn btn-primary float-left mr-3" onClick={() => viewOriginalFile(file)} theme="accent"><FcDataConfiguration /> Test Run</Button>
                    </Col>
                    <Col className="form-button" md="4">
                      {`Total Rows Count: ${totalRowCount}`}
                      
                      <br />
                      {`Total Rows processed: ${totalRowProcessed}`}
                    </Col>
                    {/* <Col className="form-button" md="4">
                    
                      {structureId ? 
                        <Button variant="primary" className="float-left mr-3" onClick={() => createEditStructure()}><FcPlus /> Update Structure</Button>
                          : 
                        (showSaveBtn && (
                          <Button variant="primary" className="float-left mr-3" onClick={() => createEditStructure()}><FcPlus /> Save Structure</Button>
                          )
                        )
                      }
                  </Col>  */}
                </Row> 


                {(isEdit || isCreate) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => createEditStructure()}
                        >
                          <FcPlus /> { isEdit ? 'Update' : 'Create' } Structure
                        </Button>
                    </Col>
                  </Row>
                )}

                {(isView) && (
                  <Row className="form-group-row">
                    <Col className="form-button" md="12">
                        <Button
                          className="btn btn-primary"
                          theme="accent"
                          onClick={() => navigate(`/project/${projectId}/structure/${structureId}/edit`)}
                        >
                          <TiEdit /> Edit Structure
                        </Button>
                    </Col>
                  </Row>
                )}

                <hr />

                {/* {viewTable && (
                  <>
                    {headerObject && (
                      <>
                        <Table>
                          <thead>
                            <tr>
                              {headerObject.map((item, index) => {
                                return (
                                  <td key={`${index}-head-headerObject`}>{item}</td>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {headerObject.map((item, index) => {
                                return (
                                  <td key={`${index}-body-headerObject`}>{headerObjectRecord[item]}</td>
                                );
                              })}
                            </tr>
                          </tbody>
                        </Table>
                      </>
                    )}
                  </>
                )} */}

                {/* {viewTable && (
                  <>
                    {trailerObject && (
                      <>
                        <Table>
                          <thead>
                            <tr>
                              {trailerObject.map((item, index) => {
                                return (
                                  <td key={`${index}-head-trailerObject`}>{item}</td>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {trailerObject.map((item, index) => {
                                return (
                                  <td key={`${index}-body-trailerObject`}>{trailerObjectRecord[item]}</td>
                                );
                              })}
                            </tr>
                          </tbody>
                        </Table>
                      </>
                    )}
                  </>
                )} */}


                {/* {viewTable && (
                  <>
                    <Container>
                      <Row>
                        <TableColumnRow
                            rows={columnsRows}
                            headers={headers}
                            clearData={clearData}
                        />
                      </Row>
                    </Container>
                    <Container>
                      <Row>
                        <TableRow
                            rows={rows}
                            clearData={clearData}
                        />
                      </Row>
                    </Container>
                  </>
                )} */}

        {viewTable && (
          <>
            {
              Object.keys(previewTable).map(function(key) {
                return ( 
                  <Row key={key}>
                    <Col>
                      <Row>
                        <Col className="mb-2">Data for {key}</Col>
                      </Row>
                      <Container>
                        <Row>
                            <TableColumnRow
                                rows={previewTable[key]}
                                headers={previewTable[key].headerData}
                                clearData={clearData}
                            />
                        </Row>
                      </Container>
                      <Container>
                          <Row>
                              <TableRow
                                  rows={previewTable[key]}
                                  clearData={clearData}
                              />
                          </Row>
                      </Container>
                    </Col>
                  </Row>
                )
              })
            }
            
          </>
      )}

              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      
    </Container>
  );
}

export default StructureCreate;
